module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "pl-header"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Praise for the authors of")]), _vm._v(" Convenient Christmas Brides ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center-bold"
  }, [_vm._v("CARLA KELLY ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“A lovely, whimsical tale with unforgettable characters and richly detailed prose.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" on “Captain Grey’s Christmas Proposal” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Regency Christmas Wishes")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-center-bold"
  }, [_vm._v("LOUISE ALLEN ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“Allen writes Regency romances that always become favorites.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Earl’s Practical Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-center-bold"
  }, [_vm._v("LAURIE BENSON")]), _vm._v(" "), _c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("“Delightfully unexpected plot twists, with lively dialogue and witty repartee.... A charmer.”")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Unexpected Countess ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc7e1e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Praise.vue
// module id = 60
// module chunks = 0